module.exports = __webpack_public_path__ + "img/1501232060.13e6a7fa.jpg";